var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OButton',{staticClass:"absolute z-1 right-0 top-0 h-8 w-8 u-center !p-0",attrs:{"size":"xs","color-scheme":'red'},on:{"click":_vm.handleDeleteArticle}},[_c('OIcon',{staticClass:"w-5",attrs:{"icon":"trash-white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }